import { gql } from '@apollo/client';

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      _id
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      _id
    }
  }
`;

export const DISABLE_USER = gql`
  mutation DisableUser($id: ObjectId!) {
    disableUser(_id: $id) {
      _id
    }
  }
`;
